import React, { Component } from "react";
// import styles from "./CostOfLiving.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../Loader/Loader";
import axios from "axios";
import ConfirmModal from "./ConfirmModal";
import EditModal from "./EditModal";
import styles from "./DataBox.scss";
import classnames from "classnames";

export default class CostOfLiving extends Component {
  constructor(props) {
    super(props);
    this.state = {
      city_data: undefined,
      datum: undefined,
      data_schema: undefined,
      showConfirmModal: false,
      showEditModal: false
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  getDataSchema = data => {
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (
        ent[0] === "transportation" ||
        ent[0] === "neighbourhood_id" ||
        ent[0] === "value"
      ) {
        return null;
      } else {
        data_schema[ent[0]] = ent[1];
      }
      return null;
    });
    this.showEditModal(data_schema);
  };

  updateTable = () => {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .get("/api/neighbourhood_data/")
      .then(res => {
        this.setState({
          city_data: res.data
        });
      })
      .catch(e => console.log(e));
  };

  showConfirmModal = datum => {
    this.setState({ showConfirmModal: true, datum: datum });
  };

  hideConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  showEditModal = datum => {
    this.setState({ showEditModal: true, datum: datum });
  };

  hideEditModal = () => {
    this.setState({ showEditModal: false });
  };

  updateOrAdd(datum, type) {
    const new_datum = { ...datum, value: datum["name"], label: datum["name"] };
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/updateneighbourhood", new_datum)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  render() {
    if (!this.state.city_data) {
      return <Loader />;
    } else {
      return (
        <div className={styles.dataBox}>
          <ConfirmModal
            show={this.state.showConfirmModal}
            handleClose={this.hideConfirmModal}
            data={this.state.datum}
            deleteData={this.deleteData}
            updateTable={this.updateTable}
            type={this.state.type}
          />
          <EditModal
            show={this.state.showEditModal}
            handleClose={this.hideEditModal}
            data={this.state.datum}
            updateOrAdd={this.updateOrAdd}
            updateTable={this.updateTable}
            type={"Neighbourhood Data"}
          />
          <div
            className={classnames("table-responsive text-nowrap", styles.table)}
          >
            <table className="table table-striped w-auto">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Neighbourhood ID</th>
                  <th scope="col">Apartment Building Total</th>
                  <th scope="col">Average Owning Cost</th>
                  <th scope="col">Average Rental Cost</th>
                  <th scope="col">Base Households</th>
                  <th scope="col">Bussing Percentage</th>
                  <th scope="col">Childcare</th>
                  <th scope="col">Dog Parks</th>
                  <th scope="col">Driving Percentage</th>
                  <th scope="col">Hospital</th>
                  <th scope="col">Long-Term Care</th>
                  <th scope="col">Median Household Income</th>
                  <th scope="col">New Structures Concentration Percentage</th>
                  <th scope="col">Profiles</th>
                  <th scope="col">Schools</th>
                  <th scope="col">Seniors Concentration Neighborhood</th>
                  <th scope="col">Students Concentration Neighborhood</th>
                  <th scope="col">Spoken Forgien Languages</th>
                  <th scope="col">Total Age 0-4</th>
                  <th scope="col">Total Elementry School Age 5-14</th>
                  <th scope="col">Total Secondary School Age 15-19</th>
                  <th scope="col">Total Undergrad Age 20-24</th>
                  <th scope="col">Total Retired Age 65-85+</th>
                  <th scope="col">Total Visible Minotities Percentage</th>
                  <th scope="col">Total Workforce</th>
                  <th scope="col">Image</th>
                  <th scope="col">Tags</th>
                  <th scope="col">Description</th>
                  <th scope="col">Total Attached Houses</th>

                  <th scope="col">Edit</th>
                </tr>
              </thead>
              <tbody>
                {this.state.city_data.map((row, i) => {
                  return (
                    <tr key={i}>
                      <td>{row["Name"]}</td>
                      <td>{row["neighbourhood_id"]}</td>
                      <td>{row["Apartment Building Total"]}</td>
                      <td>{row["Average Owning Cost"]}</td>
                      <td>{row["Average Rental Cost"]}</td>
                      <td>{row["Base Households"]}</td>
                      <td>{row["Bussing Percentage"]}</td>
                      <td>{row["Childcare"]}</td>
                      <td>{row["Dog Parks"]}</td>
                      <td>{row["Driving Percentage"]}</td>
                      <td>{row["Hospital"]}</td>
                      <td>{row["Long-Term Care"]}</td>
                      <td>{row["Median Household Income"]}</td>
                      <td>{row["New Structures Concentration Percentage"]}</td>
                      <td>{row["Profiles"]}</td>
                      <td>{row["Schools"]}</td>
                      <td>{row["Seniors Concentration Neighborhood"]}</td>
                      <td>{row["Students Concentration Neighborhood"]}</td>
                      <td>{row["Spoken Forgien Languages"]}</td>
                      <td>{row["Total Age 0-4"]}</td>
                      <td>{row["Total Elementry School Age 5-14"]}</td>
                      <td>{row["Total Secondary School Age 15-19"]}</td>
                      <td>{row["Total Undergrad Age 20-24"]}</td>
                      <td>{row["Total Retired Age 65-85+"]}</td>
                      <td>{row["Total Visible Minotities Percentage"]}</td>
                      <td>{row["Total Workforce"]}</td>
                      <td>{row["image"]}</td>
                      <td>{row["Tags"]}</td>
                      <td>{row["Description"]}</td>
                      <td>{row["Total Attached Houses"]}</td>


                      <td className="textCenter">
                        <FontAwesomeIcon
                          className={styles.cursor}
                          onClick={() => this.getDataSchema(row)}
                          style={{ color: "#323643" }}
                          icon={faEdit}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/NeighbourhoodData.js